import styled from 'styled-components';

import { FormContextValues, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { AppointmentFormBean } from '../AppointmentForm.types';

const StyledSelect = styled(Select)`
   min-width: 107px;
` as typeof Select;

const RECURRENCE_PERIOD_UNITS_LIST: Array<RecurrencePeriodUnit> = ['DAYS', 'WEEKS', 'MONTHS'];
const RECURRENCE_PERIOD_UNIT_FIELD_NAME = 'recurrencePeriodUnit';

export type RecurrencePeriodUnit = 'DAYS' | 'WEEKS' | 'MONTHS';

type RecurrencePeriodUnitFieldProps = Pick<FormContextValues<RecurrencePeriodUnitFormBeanPart>, 'register'> & {
   readonly setValue: FormContextValues<AppointmentFormBean>['setValue'];
};
type RecurrencePeriodUnitFormBeanPart = {
   [RECURRENCE_PERIOD_UNIT_FIELD_NAME]?: RecurrencePeriodUnit;
};

export const RecurrencePeriodUnitField = (props: RecurrencePeriodUnitFieldProps): JSX.Element => {
   const translate = useTranslate();

   const triggerLabelExtractor = (unit: RecurrencePeriodUnit): string => {
      return translate(appointmentsTranslationKeys.create.form.recurrencePeriodUnit.type[unit]) ?? '';
   };

   return (
      <StyledSelect<RecurrencePeriodUnit>
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register(RECURRENCE_PERIOD_UNIT_FIELD_NAME)}
         testId={RECURRENCE_PERIOD_UNIT_FIELD_NAME}
         defaultValue={'WEEKS'}
         onSelect={() => {
            props.setValue('recurrencePeriod', 1);
         }}
      >
         <Select.List items={RECURRENCE_PERIOD_UNITS_LIST}>
            {(unit) => (
               <Select.Item
                  testId={unit}
                  item={unit}
                  label={appointmentsTranslationKeys.create.form.recurrencePeriodUnit.type[unit]}
               />
            )}
         </Select.List>
      </StyledSelect>
   );
};
